import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { I18n, NgtButtonComponent, TranslatePipe } from '@corporate/ng-tebis-base-components';
import { ServerStatusService } from '../../core/services/server-status.service';

@Component({
  selector: 'tebitasks-maintenance-message',
  imports: [
    NgtButtonComponent,
    TranslatePipe,
  ],
  templateUrl: './maintenance-message.component.html',
  styleUrl: './maintenance-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaintenanceMessageComponent {

  i18n = inject(I18n);
  serverStatusService = inject(ServerStatusService);

  begin = this.serverStatusService.maintenanceBegin;
  duration = this.serverStatusService.maintenanceDuration;

  constructor() {
    this.i18n.addNamespace('maintenance');
  }
}
